const about = {
    eyebrow: 'אודות',
    title: 'מהנדס תוכנה שבונה היום עם AI',
    summary:
        'אני מהנדס AI ב-Pentera, בונה סוכני LLM ומערכות RAG בפרודקשן ואת תשתית ה-AWS שמריצה אותם. הגעתי לכאן אחרי חמש שנים של פיתוח מוצר פול-סטאק, ואני עדיין אוהב את החלקים שהם לא המודל — אורקסטרציה, retrieval, הערכה, שליטה בעלויות והתשתית ששומרת על סוכן אמין בפרודקשן.',
    getMyResume: 'הורדת קורות חיים',
    experience: 'ניסיון תעסוקתי',
    skills: 'כלים וטכנולוגיות',
    education: 'השכלה',
    beyondWork: 'מעבר לעבודה',
    factRole: 'תפקיד',
    factLocation: 'מיקום',
    factEducation: 'השכלה',
    factLanguages: 'שפות',
    educationShort: 'B.Sc במדעי המחשב',
    languagesValue: 'עברית (שפת אם) · אנגלית (רמה מקצועית)',
    degree: 'B.Sc במדעי המחשב — ממוצע 88',
    degreePlace: 'המכללה האקדמית ספיר',
    highSchool: 'תיכון אורט יד לייבוביץ׳, נתניה',
    volunteer1Title: 'עוגן קהילתי, באר שבע',
    volunteer1Text: 'ליווי והוראה של בני נוער בסיכון.',
    volunteer2Title: 'בית החולים סורוקה, המחלקה האונקולוגית',
    volunteer2Text: 'חונך אישי לילד במהלך טיפולים.',
    militaryTitle: 'שירות צבאי — צה״ל',
    militaryText: 'טכנאי טנקים במחנה נתן, באר שבע.',
};

export default about;
